import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { reveal, EASE } from "@/lib/motion";

export default function Founders() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section id="over" className="section founders" ref={ref} data-testid="over">
      <motion.div {...reveal()}>
        <h2>
          Boris
          <motion.span
            className="amp"
            initial={{ opacity: 0, scale: 0.4, rotate: -18 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.25 }}
          >
            &amp;
          </motion.span>
          <br />
          Timo.
        </h2>
        <p className="founder-line">
          Twee broers.
          <br />
          Eén opgeruimde missie.
        </p>
        <p>
          Wij willen het uitruimen van volle plekken in huis makkelijker maken. Met duidelijke
          afspraken en respect voor jouw spullen.
        </p>
      </motion.div>
      <motion.figure {...reveal(0.1)}>
        <div className="founders-img-clip">
          <motion.img
            style={{ y: imgY }}
            src="/assets/texture.webp"
            alt="Detail van nette opslag in de groene huisstijl"
            loading="lazy"
          />
        </div>
        <motion.figcaption
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5, delay: 0.35, ease: EASE }}
        >
          Ruimte om weer vooruit te kunnen.
        </motion.figcaption>
      </motion.figure>
    </section>
  );
}
